export default __webpack_public_path__ + "static/media/Learning.bc23bf26.png";